module.exports = __webpack_public_path__ + "static/media/3 SHPE group.b61fc54f.jpeg";